import RootStore from '@App/stores/root-store'
import { action, computed, makeObservable, observable } from 'mobx'

export default class ThemeStore {
    private _rootStore: RootStore
    private _currentThemeRenderId = 0

    constructor(rootStore: RootStore) {
        makeObservable<ThemeStore, '_currentThemeRenderId'>(this, {
            currentTheme: computed,
            _currentThemeRenderId: observable,
            resetCurrentTheme: action,
        })
        this._rootStore = rootStore
    }

    get currentThemeRenderId() {
        return this._currentThemeRenderId
    }

    // Force the ThemeProvider to re-render (and maybe pick up a new ThemeStore)
    resetCurrentTheme() {
        this._currentThemeRenderId = Math.floor(Math.random() * 1000000)
    }

    get currentTheme() {
        return this._rootStore.songwriterStore.optionalCurrentSongwriterId ||
            this._rootStore.uiStore.homePageState === 'songwriter'
            ? 'songwriter-standard'
            : 'member-standard'
    }
}
